import * as React from "../../_snowpack/pkg/react.js";
import * as d3 from "../../_snowpack/pkg/d3.js";
import {getAveragesFromEntries, getTextDegree} from "../utils.js";
const graphConfig = {
  fullHeight: 420,
  fullWidthRatio: 0.8,
  axisDiff: 60,
  spacer: 20,
  maxAverageRepresented: 40
};
const NationalCountsGraph = ({
  nationalCounts,
  degreeType,
  ficeCode,
  instName
}) => {
  const {
    fullHeight,
    fullWidthRatio,
    axisDiff,
    spacer,
    maxAverageRepresented
  } = graphConfig;
  const fullWidth = Math.min(window.innerWidth * fullWidthRatio, 800);
  const overMaxEntries = Object.entries(nationalCounts[degreeType]).filter(([count, idArr]) => parseInt(count) > maxAverageRepresented).map(([count, idArr]) => {
    return [
      maxAverageRepresented + 1,
      idArr.length,
      idArr.includes(ficeCode)
    ];
  }).reduce((acc, el) => {
    return [acc[0], acc[1] + el[1], acc[2] || el[2]];
  }, [maxAverageRepresented + 1, 0, false]);
  const underMaxEntries = Object.entries(nationalCounts[degreeType]).filter(([count, idArr]) => parseInt(count) <= maxAverageRepresented).map(([count, idArr]) => {
    return [
      parseInt(count),
      idArr.length,
      idArr.includes(ficeCode)
    ];
  });
  const allEntries = React.useMemo(() => [...underMaxEntries, overMaxEntries], [underMaxEntries, overMaxEntries]);
  const [maxDegreeCount, maxFreq] = getAveragesFromEntries(allEntries);
  const barWidth = (fullWidth - spacer - axisDiff) / maxDegreeCount / 2;
  React.useEffect(() => {
    const graph = d3.select("#national-counts-graph").append("svg").attr("width", fullWidth).attr("height", fullHeight);
    graph.append("g").attr("transform", `translate(${axisDiff},0)`).selectAll("rect").data(allEntries).enter().insert("rect").attr("height", ([degreeCount, instCount, isSelf]) => instCount * (fullHeight - spacer - axisDiff) / maxFreq).attr("width", barWidth).attr("transform", ([degreeCount, instCount, isSelf]) => {
      return `translate(${(fullWidth - axisDiff - spacer) / (maxDegreeCount + 1) * degreeCount + barWidth / 2},${fullHeight - axisDiff - instCount * (fullHeight - spacer - axisDiff) / maxFreq})`;
    }).attr("fill", ([degreeCount, instCount, isSelf]) => isSelf ? "rgb(248, 113, 113)" : "rgb(96, 165, 250)").append("svg:title").text(([degreeCount, instCount, isSelf]) => instCount);
    graph.append("g").attr("id", "bottom-axis").attr("transform", `translate(0, ${fullHeight - axisDiff})`).call(d3.axisBottom(d3.scaleLinear().domain([0, maxDegreeCount + 1]).range([axisDiff, fullWidth - spacer])).ticks(Math.min(maxDegreeCount + 1, maxAverageRepresented + 1)));
    graph.append("g").attr("id", "left-axis").attr("transform", `translate(${axisDiff},-${axisDiff - spacer})`).call(d3.axisLeft(d3.scaleLinear().domain([0, maxFreq]).range([fullHeight - spacer, axisDiff])).ticks(maxFreq > 12 ? maxFreq > 24 ? maxFreq > 32 ? maxFreq / 4 : maxFreq / 3 : maxFreq / 2 : maxFreq));
    graph.selectAll("#bottom-axis").selectChildren(".tick").selectChildren("text").attr("transform", `translate(${barWidth}, 2)`).text((x) => {
      if (x === maxDegreeCount + 1 || x > maxAverageRepresented + 1)
        return "";
      if (x === maxAverageRepresented + 1)
        return `>`;
      return `${x}`;
    });
    graph.append("text").text("Number of Universities").attr("transform", `translate(25, ${fullHeight / 2 + 70}) rotate(-90)`);
    graph.append("text").text(`Average Number of Physics ${degreeType} Degrees`).attr("transform", `translate(${fullWidth / 2 - 175}, ${fullHeight - 10})`);
    return () => {
      d3.select("#national-counts-graph").selectChild("svg").remove();
    };
  }, [
    allEntries,
    axisDiff,
    barWidth,
    degreeType,
    fullHeight,
    fullWidth,
    maxAverageRepresented,
    maxDegreeCount,
    maxFreq,
    spacer
  ]);
  return /* @__PURE__ */ React.createElement("div", {
    className: "w-full flex flex-col items-center py-4 mt-6 text-lg"
  }, /* @__PURE__ */ React.createElement("div", {
    id: "national-counts-graph"
  }), /* @__PURE__ */ React.createElement("span", {
    className: "text-lg flex items-center justify-center mt-4 text-center"
  }, /* @__PURE__ */ React.createElement("h2", {
    className: "border-2 border-red-400 bg-red-400 bg-opacity-20 m-2 px-2"
  }, getTextDegree(degreeType), " Degrees in Physics issued by ", instName), /* @__PURE__ */ React.createElement("span", {
    className: "italic"
  }, "compared to"), /* @__PURE__ */ React.createElement("h2", {
    className: "border-2 border-blue-400 bg-blue-400 bg-opacity-20 m-2 px-2"
  }, "other ", getTextDegree(degreeType), " Degree programs in Physics nationally")));
};
export default NationalCountsGraph;
